// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export interface HKMProduct {
  pr_id: number;
  pr_company: string;
  pr_name: string;
  pr_code?: string;
  pr_group?: number;
  pr_uom?: string;
  pr_rate?: number;
  pr_srate?: number;
  pr_image?: string;
  pr_flag?: string;
  group_name?: string;
  gp_name?: string;
}

export const hkmproductApi = api
  .enhanceEndpoints({ addTagTypes: ['HKMProduct', 'HKMProductStock'] })
  .injectEndpoints({
    endpoints: builder => ({
      getHKMProducts: builder.query<any[], string>({
        query: cid => `hkmproduct/${cid}`,
        providesTags: ['HKMProduct']
      }),
      getHKMProductById: builder.query<any, string | number>({
        query: id => `hkmproduct/byid/${id}`,
        providesTags: ['HKMProduct']
      }),
      insertHKMProduct: builder.mutation({
        query: product => ({
          url: `hkmproduct/`,
          method: 'POST',
          body: product
        }),
        invalidatesTags: ['HKMProduct']
      }),
      updateHKMProduct: builder.mutation({
        query: product => ({
          url: `hkmproduct/`,
          method: 'PUT',
          body: product
        }),
        invalidatesTags: ['HKMProduct']
      }),
      getHKMProductStock: builder.query<{ pr_id: number; pr_stock: number }[], void>({
        query: () => `hkmproduct/stock/list`,
        providesTags: ['HKMProductStock']
      }),
      updateHKMProductImage: builder.mutation<any, { pr_id: number; pr_image: string }>({
        query: body => ({
          url: `hkmproduct/image`,
          method: 'PUT',
          body
        }),
        invalidatesTags: ['HKMProduct']
      }),
      deleteHKMProduct: builder.mutation({
        query: id => ({
          url: `hkmproduct/${id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['HKMProduct']
      })
    }),
    overrideExisting: false
  });

export const {
  useGetHKMProductsQuery,
  useGetHKMProductByIdQuery,
  useInsertHKMProductMutation,
  useUpdateHKMProductMutation,
  useGetHKMProductStockQuery,
  useUpdateHKMProductImageMutation,
  useDeleteHKMProductMutation
} = hkmproductApi;
